import { Grid, Stack, Switch, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { alert } from "src/services/alert";
import UserInfo from "src/components/common/UserInfo";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import MerchantInfo from "src/components/common/MerchantInfo";

const UserMergeDialog = ({ user, open, onReload, onClose }) => {
  const [toUser, setToUser] = useState({});

  const [form, setForm] = useState({
    remark: "",
    withXfq: false,
    withTxq: false,
    withDhq: false,
    withPointsGreen: false,
    withHehuo: false,
    withDaiyan: false,
    withAgent: false,
  });

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleDialogConfirm() {
    // if (!form.remark) return alert("请输入修改原因");

    const { msg } = await asyncRequest({
      path: "/user/merge",
      data: {
        ...form,
        fromUid: user.uid,
        toUid: toUser.uid,
      },
    });

    alert(msg, "success");
    onClose();
    onReload();
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        setToUser(val);
      },
    });
  }

  return (
    <FormDialog title="资产转移" open={open} onClose={onClose} onConfirm={handleDialogConfirm} contentStyle={{ maxWidth: 600}}>
      <Grid container>
        <Grid item sm={6}>
          <FormItem title="被转用户" required>
            <Stack direction="row" alignItems="center" spacing={2}>
              <UserInfo {...user} enablePreview={false} />
            </Stack>
          </FormItem>
        </Grid>
        <Grid item sm={6}>
          <FormItem title="转至用户" required>
            <Stack direction="row" alignItems="center" spacing={2} onClick={handleSelectUser}>
              {<UserInfo {...toUser} enablePreview={false} />}
            </Stack>
          </FormItem>
        </Grid>

        <Grid item sm={6}>
          <FormItem title="合伙人">
            <Switch checked={form.withHehuo} onChange={(e) => handleIptChange("withHehuo", e.target.checked)} />
          </FormItem>
        </Grid>
        <Grid item sm={6}>
          <FormItem title="代言人">
            <Switch checked={form.withDaiyan} onChange={(e) => handleIptChange("withDaiyan", e.target.checked)} />
          </FormItem>
        </Grid>

        <Grid item sm={6}>
          <FormItem title="代理">
            <Switch checked={form.withAgent} onChange={(e) => handleIptChange("withAgent", e.target.checked)} />
          </FormItem>
        </Grid>
        <Grid item sm={6}>
          <FormItem title="消费券">
            <Switch checked={form.withXfq} onChange={(e) => handleIptChange("withXfq", e.target.checked)} />
          </FormItem>
        </Grid>
        <Grid item sm={6}>
          <FormItem title="兑换券">
            <Switch checked={form.withDhq} onChange={(e) => handleIptChange("withDhq", e.target.checked)} />
          </FormItem>
        </Grid>
        <Grid item sm={6}>
          <FormItem title="添星券">
            <Switch checked={form.withTxq} onChange={(e) => handleIptChange("withTxq", e.target.checked)} />
          </FormItem>
        </Grid>
        <Grid item md={6}>
          <FormItem title="绿色积分">
            <Switch checked={form.withPointsGreen} onChange={(e) => handleIptChange("withPointsGreen", e.target.checked)} />
          </FormItem>
        </Grid>
      </Grid>

      <FormItem title="备注">
        <TextField fullWidth value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} rows={4} multiline />
      </FormItem>
    </FormDialog>
  );
};

export default UserMergeDialog;
